import { Box, Button, Typography } from "@mui/material";

interface DocLoadErrorProps {
  onRetry: () => void;
}

export const DocLoadError = ({ onRetry }: DocLoadErrorProps) => (
  <Box sx={{ py: 12, textAlign: "center" }}>
    <Typography sx={{ mb: 2 }}>This doc couldn't be loaded.</Typography>
    <Button onClick={onRetry}>Try again</Button>
  </Box>
);
